import CollegeService from '@services/college';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useGetCollegesSaved = () =>
  useQuery({
    queryKey: ['get-colleges-saved'],
    queryFn: () => CollegeService.getCollegesSaved(),
  });

export const useUnsaveFavoriteCollege = (collegeId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['unsave-favorite-college'],
    mutationFn: () => CollegeService.unsaveFavoriteCollege(collegeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get-colleges-saved'] });
    },
  });
};
